import cn from 'classnames';
import React, { FC, useEffect } from 'react';
import { IPopupProps } from './PopupMessage.types';
import { useTranslation } from 'react-i18next';
import { DOM_ID } from '@UILayer/UILayer.types';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getDeviceInfo, getGlobalStyles } from '@Managers/Redux/AppState/AppState';

// STYLES
import styles from '@UILayer/UILayer.scss';
import { Button } from '@UILayer/Inputs/Button';

export const Popup: FC<IPopupProps> = ({ children, className, onClose, isPopupOpen, msgType = 'standard' }) => {
    const handleOverlayClick = (e: React.MouseEvent<HTMLElement>) => {
        if (e.target === e.currentTarget && onClose) {
            onClose();
        }
    };
    const { t } = useTranslation();
    const globalStyles = useAppSelector(getGlobalStyles);
    const device = useAppSelector(getDeviceInfo);

    useEffect(() => {}, []);

    const containerCN = cn(
        styles.popup_container,
        styles.md,
        styles[msgType],
        globalStyles.wcaMode,
        globalStyles.screenSize,
        globalStyles.orientation,
        globalStyles.isTablet
    );

    return (
        <div
            className={styles.popup_overlay}
            onPointerDown={handleOverlayClick}
            role="dialog"
            aria-modal="true"
            aria-description={t(`POPUP_MESSAGE_MODAL_${msgType.toUpperCase()}_WCA_DESCRIPTION`)}
        >
            <div className={cn(containerCN)}>
                <div className={styles.popup_inner}>
                    <Button
                        id={DOM_ID.BUTTON_CLOSE_POPUP_MESSAGE}
                        description={t(`POPUP_MESSAGE_CLOSE_WCA_DESCRIPTION`)}
                        className={cn(styles.close_button)}
                        onChange={() => onClose()}
                        dataDismiss="modal"
                    ></Button>
                    <div className={styles.popup_content}>{children}</div>
                </div>
            </div>
        </div>
    );
};
